@if ((timeLeft$ | async); as t) {
  <div class="timer"  [lxResponsiveClass]="{ horizontal: 'timer', vertical: 'timer-handset' }">
    <div [lxResponsiveClass]="{ horizontal: 'timer-text', vertical: 'timer-text-handset' }">
      <span [class.expired]="expired" [hidden]="expired">
        {{ !expired ? 'Offer Expires In: ' : 'Sorry, Offer Expired: ' }}
      </span>
      &nbsp;
    </div>

    <div
      [class.expired]="expired"
      [lxResponsiveClass]="{ horizontal: 'timer-text', vertical: 'timer-text-handset' }">
      <span id="days" [hidden]="t.daysToDday <= 0">{{ t.daysString }}</span>
      <span [hidden]="t.daysToDday <= 0"> Day(s) </span>
      <span id="hours">{{ !expired ? t.hoursString : 0 }} Hrs </span>
      <span id="minutes">{{ !expired ? t.minutesString : 0 }} Min </span>
      <span id="seconds">{{ !expired ? t.secondsString : 0 }} Sec </span>
    </div>
  </div>
} @else {
  ...
}
